import { render, staticRenderFns } from "./OpenstackZstack.vue?vue&type=template&id=2fd64eb3"
import script from "./OpenstackZstack.vue?vue&type=script&lang=js"
export * from "./OpenstackZstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports